import axios from "axios";
import Cookies from "js-cookie";

let configured = false;


export function configureAxios() {
    if (configured) return;
    configured = true;

    axios.defaults.withCredentials = true;

    axios.interceptors.request.use(
        (config) => {
            const authorization = Cookies.get("Authorization");

            if (authorization) {
                config.headers = config.headers || {};
                config.headers.Authorization = authorization;
            }

            return config;
        },
        (error) => Promise.reject(error)
    );
}
